// Copyright (c) 2025 WiseTime. All rights reserved.

// When localStorage key is changed/renamed, we need to remove it from the user's browser.
export const sanitizeLocalStorage = (keys: string[]) => {
  keys.forEach(key => localStorage.removeItem(key))
}
